<template>
  <div class="tw-flex tw-flex-col tw-gap-10 tw-items-center">
    <div class="tw-flex tw-flex-col tw-gap-2 tw-items-center">
      <h2 class="tw-text-xl tw-font-semibold tw-text-gray-700">
        Connect to Salesforce
      </h2>
      <p class="tw-text-base tw-max-w-md tw-text-gray-500">
        Before connecting to Salesforce,
        please make sure you have installed the YourStake app in your Salesforce org.
      </p>
    </div>

    <div class="tw-flex tw-gap-5">
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
        <a
          href="https://login.salesforce.com/packaging/installPackage.apexp?p0=04tfK0000002s9BQAQ"
          target="_blank"
          class="button-base tw-bg-slate-500 hover:tw-bg-slate-600 tw-text-gray-200 hover:tw-text-white"
        >
          <i class="fa fa-wrench" />
          Install App
        </a>
        <p class="tw-text-sm tw-max-w-xs tw-px-1 tw-text-gray-500">
          <!-- Any helper text we want to include about the this option -->
        </p>
      </div>

      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
        <a
          :href="url"
          target="_blank"
          class="button-base tw-bg-sky-600 hover:tw-bg-sky-700 tw-text-gray-200 hover:tw-text-white"
        >
          <i class="fa fa-plug" />
          Connect!
        </a>
        <p class="tw-text-sm tw-max-w-xs tw-px-1 tw-text-gray-500">
          If you aren't sure, try this first.
          If you see an error page, you probably need to install the app.
        </p>
      </div>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'SalesforcePreConnect',
  components: {
    // Subcomponents
  },
  props: {
    // Inputs
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // Local variables
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>
  .button-base {
    @apply tw-text-base;
    @apply tw-px-4 tw-py-2 tw-rounded-md tw-border-none;
    @apply tw-flex tw-gap-2 tw-items-center tw-justify-center;
  }
</style>
